/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Powered_ByInputs */

const en_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by`)
};

const es_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollado por`)
};

const fr_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par`)
};

const de_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by`)
};

const ja_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by`)
};

const zh_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由以下技术驱动：`)
};

const ar_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشغل بواسطة`)
};

const id_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didukung oleh`)
};

const it_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerto da`)
};

const ru_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При поддержке`)
};

const pt_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvido por`)
};

const ko_powered_by = /** @type {(inputs: Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by`)
};

/**
* | output |
* | --- |
* | "Powered by" |
*
* @param {Powered_ByInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const powered_by = /** @type {((inputs?: Powered_ByInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Powered_ByInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_powered_by(inputs)
	if (locale === "es") return es_powered_by(inputs)
	if (locale === "fr") return fr_powered_by(inputs)
	if (locale === "de") return de_powered_by(inputs)
	if (locale === "ja") return ja_powered_by(inputs)
	if (locale === "zh") return zh_powered_by(inputs)
	if (locale === "ar") return ar_powered_by(inputs)
	if (locale === "id") return id_powered_by(inputs)
	if (locale === "it") return it_powered_by(inputs)
	if (locale === "ru") return ru_powered_by(inputs)
	if (locale === "pt") return pt_powered_by(inputs)
	return ko_powered_by(inputs)
});